import '../scss/site.scss';

(($) => {

  $(document).ready(() => {});

  $('.accordion .item').on({
    'mouseenter': (e)=> {
      let element = $(e.target).closest('.item');
      let parent = $(e.target).parents('.accordion');
      parent.addClass('hover');
      parent.find('.item').removeClass('active');
      element.addClass('active');
    },
    'mouseleave': (e)=> {
      let element = $(e.target).closest('.item');
      let parent = $(e.target).parents('.accordion');
      parent.removeClass('hover');
      parent.find('.item').removeClass('active');
    }
  });

  $('.menu a').on('click', (e)=> {
    e.preventDefault();
    let target = $($(e.target).attr('href'));
    $([document.documentElement, document.body]).animate({
        scrollTop: target.offset().top
    }, 2000);
  });

  $(document).on('click', '.mobile_trigger', function() {
    $($(this).data('trigger-target')).toggleClass('active');
  });

})(jQuery);